import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../Store/store";
import { setDeleteModalVisibleRedux, setQnaLoadingRedux, setQnaReplyModalVisibleRedux, setQnaReplyStringRedux, setSelectedQnaIdRedux, setSelectedQnaPageRedux, setSelectedQnaTitleRedux } from "../../Store/slices/qnaSlice";
import ListQna from "./components/ListQna";
import AddQna from "./components/AddQna";
import UpdateQna from "./components/UpdateQna";
import DeleteQna from "./components/DeleteQna";
import axios from "axios";
import { useState } from "react";
import toast from "react-hot-toast";

export const useQnaHook = () => {
    const BASE_URL = 'https://api.eatwellmama.com'
    const {
        selectedQnaPage,
        qnaLoading,
    } = useSelector((state: RootState) => state.qna.value);
    const { accessToken } = useSelector((state: RootState) => state.auth.value);
    const dispatch = useDispatch();

    const [qnas, setQnas] = useState<any>(null);
    const [lastQnaId, setLastQnaId] = useState<string | null>(null);
    const [loadingMore, setLoadingMore] = useState<boolean>(false);
    const [hasMoreQnas, setHasMoreQnas] = useState<boolean>(true);
    const [qnaToAddTitle, setQnaToAddTitle] = useState<string>('');
    const [qnaToAddDesc, setQnaToAddDesc] = useState<string>('');
    // const [qnaTags, setQnaTags] = useState<string>('');

    const setSelectedQnaPage = (page: number) => {
        dispatch(setSelectedQnaPageRedux(page));
    };

    const returnSelectedQnaPage = () => {
        switch (selectedQnaPage) {
            case 1:
                return <ListQna />;
            case 2:
                return <AddQna />;
            default:
                return <ListQna />;
        }
    };

    const fetchQnas = async () => {
        dispatch(setQnaLoadingRedux(true));
        setHasMoreQnas(true);
        await axios.get(
            `${BASE_URL}/api/qna/getLast10QnaForAdmin`,
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            console.log(response.data);
            let sortQnasByisDeleted = response.data.data.sort((a: any, b: any) => {
                return a.isDeleted - b.isDeleted;
            });
            setQnas(sortQnasByisDeleted);
            setLastQnaId(response.data.lastQnaId ?? null);
            setHasMoreQnas(!!response.data.lastQnaId);
            dispatch(setQnaLoadingRedux(false));
        }).catch((error) => {
            console.log(error);
            dispatch(setQnaLoadingRedux(true));
            setLastQnaId(null);
        });
    };

    const fetchMoreQnas = async () => {
        if (!lastQnaId || loadingMore || !hasMoreQnas) return;

        setLoadingMore(true);
        await axios.get(
            `${BASE_URL}/api/qna/getMoreQna`,
            {
                params: { lastQnaId },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then((response) => {
            const newQnas = response.data.data ?? [];
            if (newQnas.length > 0) {
                let sortQnasByisDeleted = newQnas.sort((a: any, b: any) => {
                    return a.isDeleted - b.isDeleted;
                });
                setQnas((prev: any) => prev ? [...prev, ...sortQnasByisDeleted] : sortQnasByisDeleted);
            }
            setLastQnaId(response.data.lastQnaId ?? null);
            setHasMoreQnas(!!response.data.lastQnaId);
            setLoadingMore(false);
        }).catch((error) => {
            console.log(error);
            setLoadingMore(false);
        });
    };

    const searchQnas = async (searchQuery: string) => {
        await axios.get(
            `${BASE_URL}/api/qna/searchQna`,
            {
                params: {
                    searchQuery: searchQuery,
                },
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                }
            }
        ).then((response) => {
            console.log("SEARCH_QNA_RESPONSE:", response.data);
            let sortQnasByisDeleted = response.data.data.sort((a: any, b: any) => {
                return a.isDeleted - b.isDeleted;
            });
            setQnas(sortQnasByisDeleted);
        }).catch((error) => {
            console.log("SEARCH_QNA_ERROR:", error);
        });
    };

    const addNewQna = async () => {
        dispatch(setQnaLoadingRedux(true));
        await axios.post(
            `${BASE_URL}/api/qna/addNewQnaForAdmin`,
            {
                qnaTitle: qnaToAddTitle,
                qnaQuestion: qnaToAddDesc,
                qnaTags: [],
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then(async (response) => {
            console.log(response.data);
            toast.success('Qna added successfully');
            await fetchQnas();
            dispatch(setSelectedQnaPageRedux(1));
            dispatch(setQnaLoadingRedux(false));
        }).catch((error) => {
            console.log(error);
            dispatch(setQnaLoadingRedux(true));
        });
    };

    const deleteQnaFromAdminSide = async (qnaId: string) => {
        dispatch(setQnaLoadingRedux(true));
        await axios.post(
            `${BASE_URL}/api/qna/deleteQnaFromAdminSide`,
            {
                qnaId: qnaId,
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then(async (response) => {
            console.log(response.data);
            toast.success('Qna deleted successfully');
            await fetchQnas();
            dispatch(setSelectedQnaPageRedux(1));
            dispatch(setQnaLoadingRedux(false));
            dispatch(setSelectedQnaIdRedux(''))
            dispatch(setSelectedQnaTitleRedux(''))
            dispatch(setDeleteModalVisibleRedux(false))
        }).catch((error) => {
            console.log(error);
            dispatch(setQnaLoadingRedux(true));
        });
    };

    const replyQnaFromAdminSide = async (qnaId: string, replyString: string) => {
        dispatch(setQnaLoadingRedux(true));
        await axios.post(
            `${BASE_URL}/api/qna/createNewQnaReply`,
            {
                qnaId: qnaId,
                qnaReply: replyString,
            },
            {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            }
        ).then(async (response) => {
            console.log(response.data);
            toast.success('Qna replied successfully');
            await fetchQnas();
            dispatch(setSelectedQnaPageRedux(1));
            dispatch(setQnaLoadingRedux(false));
            dispatch(setSelectedQnaIdRedux(''))
            dispatch(setSelectedQnaTitleRedux(''))
            dispatch(setQnaReplyStringRedux(''))
            dispatch(setQnaReplyModalVisibleRedux(false))
        }).catch((error) => {
            console.log(error);
            dispatch(setQnaLoadingRedux(true));
        });
    };


    return {
        selectedQnaPage,
        setSelectedQnaPage,
        returnSelectedQnaPage,
        fetchQnas,
        fetchMoreQnas,
        searchQnas,
        qnas,
        qnaLoading,
        loadingMore,
        hasMoreQnas,
        qnaToAddTitle,
        setQnaToAddTitle,
        qnaToAddDesc,
        setQnaToAddDesc,
        addNewQna,
        deleteQnaFromAdminSide,
        replyQnaFromAdminSide,
    };
};